/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/ApprovalMatrixHeader.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Approval Matrix
 *
 * PURPOSE:
 * Approval Matrix Page Header
 *
 ******************************************************************************/

import React from "react";

export default function ApprovalMatrixHeader({

    title,

    subtitle,

    actions,

}) {

    return (

        <div
            className="card shadow-sm mb-3 border-0"
            style={{
                borderRadius: "12px",
            }}
        >

            <div
                className="card-body"
                style={{

                    background:
                        "linear-gradient(90deg,#0d6efd,#4f8dfd)",

                    color: "#ffffff",

                    borderRadius: "12px",

                }}
            >

                <div
                    className="
                        d-flex
                        justify-content-between
                        align-items-center
                        flex-wrap
                    "
                >

                    <div>

                        <h4 className="mb-1">

                            {title}

                        </h4>

                        {subtitle && (

                            <small>

                                {subtitle}

                            </small>

                        )}

                    </div>

                    <div>

                        {actions}

                    </div>

                </div>

            </div>

        </div>

    );

}